module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('simple-button', {
    class: {
      'interactive-button__button': true,
      'interactive-button__button--inactive': _vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled,
      "text": _vm.label
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407de579"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/simpleButton/InteractiveSimpleButton.vue
// module id = 2457
// module chunks = 0